import React from "react";
import { useRouteMatch, useHistory } from "react-router-dom";

const SurveyDone = () => {
  const match = useRouteMatch("/done/:id/:serviceName");
//   const history = useHistory();
//   const goHome = () => history.push(`/survey/${match.params.id}`);

  return (
    <div className="container">
      <h1 className="mb-2 mt-3">Gracias por participar</h1>
      <p>
        En el MOPC trabajamos constantemente para mejorar nuestros servicios.
        Las respuestas recibidas son importantes para nosotros, pues nos ayudan
        en la búsqueda de la mejora continua de nuestros procesos. Por esto
        agradecemos enormemente haber dedicado su tiempo completando esta
        encuesta y hacerle extensiva la invitación para continuar brindándonos
        su apoyo.
      </p>
      <div className="text-right">
        <a
          href={`/survey/${match.params.id}/${match.params.serviceName}`}
          className="btn btn-info px-3 text-uppercase mb-5"
          type="submit"
        >
          Regresar a la encuesta
        </a>
      </div>
    </div>
  );
};

export default SurveyDone;
